import { finalize, catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { IAppConfig, APP_CONFIG } from '../../../app.config';
import { Observable } from 'rxjs';
import { LocalDate } from '../../../core/model/local-date';
import { DataService } from '../../../core/service/base/data.service';
import { InvoicePeriodItem } from '../../model/invoice-period';
import { Company } from '../../../rent/model/company';
import { InvoiceReminder } from '../../model/invoice-reminder';

@Injectable()
export class InvoiceReminderService extends DataService<InvoiceReminder> {
  private readonly _defaultFilterFields: string[] = ['company', 'fromDate', 'toDate', 'invoiceRecipient'];

  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    super(_client, config, _messageService, InvoiceReminder, _progressBar, 'invoice-reminder');
  }

  getFilterDefinition(): Observable<{
    company: string;
    companies: Company[];
    fromDate: string;
    toDate: string;
    invoiceRecipient: string;
    dateLimits: InvoicePeriodItem[];
    selectedFields: string[];
    defaultFields: string[];
    hasGuarantors?: boolean;
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          company: res.company ? res.company : '',
          companies: Array.isArray(res.companies) ? res.companies.map(x => Object.assign(new Company(), x)) : [],
          fromDate: res.fromDate ? new LocalDate(res.fromDate.year, res.fromDate.month, 1).toISOString() : res.fromDate,
          toDate: res.toDate
            ? new LocalDate(res.toDate.year, res.toDate.month, LocalDate.daysInMonth(res.toDate.year, res.toDate.month)).toISOString()
            : res.toDate,
          invoiceRecipient: res.invoiceRecipient ? res.invoiceRecipient : '',
          dateLimits: Array.isArray(res.dateLimits) ? res.dateLimits.map(x => Object.assign(new InvoicePeriodItem(), x)) : [],
          selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
          hasGuarantors: res.hasGuarantors,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  export(ids: string[]): Observable<File> {
    return super.exportDataItems(ids, 'Paminnelse.xlsx');
  }

  mapFilterValue(key: string, value: any): any {
    if ((key === 'fromDate' || key === 'toDate') && value) return LocalDate.fromDate(value);
    return super.mapFilterValue(key, value);
  }
}
